import React from "react";
import {
  List,
  Datagrid,
  Edit,
  SimpleForm,
  TextField,
  EditButton,
  DisabledInput,
  TextInput,
  Filter,
} from "react-admin";

const InsuranceFilter = (props) => (
  <Filter {...props}>
    <TextInput source="name" label="User name" alwaysOn/>
    <TextInput source="code" label="User code" alwaysOn/>
    <TextInput source="level" label="Course level" alwaysOn/>
  </Filter>
);

export const InsuranceList = props => (
  <List {...props} filters={<InsuranceFilter/>} filter={{is_published: true}}>
    <Datagrid>
      <TextField source="key" label="#"/>
      <TextField source="created_at" label="Date"/>
      <TextField source="code"/>
      <TextField source="price"/>
      <TextField source="course_level"/>
      <TextField source="user_code"/>
      <TextField source="user_name"/>
      <TextField source="user_email"/>
      <TextField source="status"/>
      <EditButton basePath="/insurance"/>
    </Datagrid>
  </List>
);

export const InsuranceEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <DisabledInput source="key" label="#"/>
      <DisabledInput source="created_at" label="Date"/>
      <DisabledInput source="code"/>
      <DisabledInput source="price"/>
      <DisabledInput source="course_level"/>
      <DisabledInput source="user_code"/>
      <DisabledInput source="user_name"/>
      <DisabledInput source="user_email"/>
      <DisabledInput source="status"/>
    </SimpleForm>
  </Edit>
);
